import { FilterOption, FilterOptionSelect } from 'features/filters/types'

const safeDecodeURIComponent = (value: string): string => {
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

export const parseThemeFilterValue = (
  value: string,
): { theme: string; subtheme: string } | null => {
  const delimiterIndex = value.indexOf(': ')
  if (delimiterIndex === -1) {
    return null
  }
  return {
    theme: value.slice(0, delimiterIndex),
    subtheme: value.slice(delimiterIndex + 2),
  }
}

export const getCatalogSubthemeNameFromBackend = (
  themeName: string,
  subthemeName: string,
  defaultFilterList: FilterOption[],
): string => {
  const decodedSubthemeName = safeDecodeURIComponent(subthemeName).trim()
  const filterOption = defaultFilterList.find(
    (option): option is FilterOptionSelect =>
      'values' in option && option.field === 'theme',
  )
  if (!filterOption) {
    return decodedSubthemeName
  }

  const matchedSubtheme = filterOption.values.find((value) => {
    const parsed = parseThemeFilterValue(value.value)
    if (!parsed) {
      return false
    }
    return (
      parsed.theme.toLowerCase() === themeName.toLowerCase() &&
      parsed.subtheme.toLowerCase() === decodedSubthemeName.toLowerCase()
    )
  })

  if (!matchedSubtheme) {
    return decodedSubthemeName
  }

  return (
    parseThemeFilterValue(matchedSubtheme.value)?.subtheme ??
    decodedSubthemeName
  )
}
